import { hearingIncludes } from '../../constants/includes';
import { buildIncludesString } from '../../utilities/utilityFunctions';
import { BaseConnector } from './baseConnector';

class HearingConnector extends BaseConnector {
  static defaultHearingIncludes = buildIncludesString(
    hearingIncludes.contents,
    hearingIncludes.contentTypes,
  );

  getHearings(includes) {
    var url = `${this.baseApiUrl}/hearing?include=${
      includes ?? HearingConnector.defaultHearingIncludes
    }`;
    return this.authFetch(url);
  }

  getPaginatedHearings(includes, pageIndex, pageSize, orderBy, filters = null) {
    var url = `${this.baseApiUrl}/hearing?include=${
      includes ?? HearingConnector.defaultHearingIncludes
    }&PageIndex=${pageIndex}&PageSize=${pageSize}`;
    if (filters.length > 0) {
      url += `&Filters=${JSON.stringify(filters)}`;
    }

    url += `&OrderBy=${JSON.stringify(orderBy)}`;

    return this.authFetch(url);
  }

  getHearing(hearingId, includes) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}?include=${
      includes ?? HearingConnector.defaultHearingIncludes
    }`;
    return this.authFetch(url);
  }

  // Special in the sense that it doesn't require a payload
  createHearing() {
    var url = `${this.baseApiUrl}/hearing?include=${HearingConnector.defaultHearingIncludes}`;
    return this.authPost(url);
  }

  updateHearing(hearingId, hearing) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}?include=${HearingConnector.defaultHearingIncludes}`;
    return this.authPatch(url, hearing);
  }

  deleteHearing(hearingId) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}`;
    return this.authDelete(url);
  }

  forceDeleteHearing(hearingId) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/force`;
    return this.authDelete(url);
  }

  updateFieldContent(hearingId, hearingStatusId, notifyAboutChanges, formData) {
    var url = `${
      this.baseApiUrl
    }/hearing/${hearingId}/fieldContent?hearingStatusId=${
      hearingStatusId || '0'
    }&notifyAboutChanges=${notifyAboutChanges}`;
    return this.authMultipartFormPatch(url, formData);
  }

  createCommentContent(hearingId, formData) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/comment`;
    return this.authMultipartFormPost(url, formData);
  }

  updateCommentContent(hearingId, commentId, formData) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/comment/${commentId}/content`;
    return this.authMultipartFormPatch(url, formData);
  }

  updateComment(hearingId, commentId) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/comment/${commentId}`;
    return this.authPatch(url);
  }

  uploadReviewers(hearingId, models) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/reviewers`;
    return this.authPost(url, models);
  }

  uploadCsvInvitees(hearingId, invitationSourceId, formData) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/invite/${invitationSourceId}/csv`;
    return this.authMultipartFormPost(url, formData);
  }

  uploadExcelInvitees(hearingId, invitationSourceId, formData) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/invite/${invitationSourceId}/excel`;
    return this.authMultipartFormPost(url, formData);
  }

  uploadPersonalInvitees(hearingId, invitationSourceId, dtos) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/invite/${invitationSourceId}/personal`;
    return this.authPost(url, dtos);
  }

  uploadInvitationGroupInvitees(
    hearingId,
    invitationSourceId,
    invitationGroupId,
  ) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/invite/${invitationSourceId}/invitationGroup/${invitationGroupId}`;
    return this.authPost(url);
  }

  deleteInvitationSource(hearingId, invitationSourceName) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/invitationSource/${invitationSourceName}`;
    return this.authDelete(url);
  }

  deleteInvitationSourceMappings(
    hearingId,
    invitationSourceMappingIds,
    deleteFromAllInvitationSources,
  ) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/invitationSourceMappings/delete?deleteFromAllInvitationSources=${deleteFromAllInvitationSources}`;
    return this.authPost(url, invitationSourceMappingIds);
  }
}

export { HearingConnector };
